import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { TutorialButton } from '@ro-components/Tutorial';

export const radarTutorial = (id, buttonText) => [
  {
    element: '.radar_shortcut',
    intro: 'W opcjach radarowych również stworzysz skrót.'
  },
  {
    element: '.radar_no_images',
    intro: 'Możesz również ustawić długości osi czasu. Od 6 - 24 godzin, wszystko pięknie renderowane bez przeładowań.'
  },
  {
    element: '.radar_alpha',
    intro: 'Tu ustawisz przezroczystość skanu radarowego. Alpha od 0 - 100%'
  },
  {
    element: '.radar_radars',
    intro: `To submenu służy do zmiany typu radaru. ${ReactDOMServer.renderToStaticMarkup(
      <TutorialButton id={id} text={buttonText} />
    )}`
  }
];
